
import * as S from './styles';
import BottomBarLogo from '../../../../components/NavBar/BottomBar/BottomBarLogo';

export function BottomBar () {

  return (
    <S.Container>
      <BottomBarLogo />
      <S.OptionsContainer>
        {/* <Tooltip>
          <TooltipTrigger asChild>
            <BottomBarItem linkTo='/' iconName='ion:home' open={collapsed}>Home</BottomBarItem>
          </TooltipTrigger>
          <TooltipContent side='bottom' sideOffset={10} avoidCollisions collisionPadding={10}>
            Home
          </TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <BottomBarItem linkTo='/extrato' iconName='fluent:payment-28-filled' open={collapsed} />
          </TooltipTrigger>
          <TooltipContent side='bottom' sideOffset={10} avoidCollisions collisionPadding={10}>
            Extrato
          </TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <BottomBarItem iconName='dashicons:money-alt' open={collapsed} />
          </TooltipTrigger>
          <TooltipContent side='bottom' sideOffset={10} avoidCollisions collisionPadding={10}>
            Pagamentos
          </TooltipContent>
        </Tooltip>

        <Tooltip>
          <TooltipTrigger asChild>
            <BottomBarItem iconName='ic:baseline-history' open={collapsed} />
          </TooltipTrigger>
          <TooltipContent side='bottom' sideOffset={10} avoidCollisions collisionPadding={10}>
            Teste
          </TooltipContent>
        </Tooltip> */}

      </S.OptionsContainer>
    </S.Container>
  )
}
